(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("headerthemetoggle", [], factory);
	else if(typeof exports === 'object')
		exports["headerthemetoggle"] = factory();
	else
		root["headerthemetoggle"] = factory();
})(this, () => {
return 